<template>
  <div>
    <b-overlay
      :show="show"
      :variant="variant"
      :opacity="opacity"
      :blur="blur"
      rounded="lg"
      spinner-variant="primary"
    >
      <div class="conf-wrapper" v-if="appointment">
        <i18n1
          class="text-right bg-light-info br-12 w-20 lang-mb"
          v-if="!enterRoom && !testConference"
        />
        <span class="clearfix"></span>
        <div
          v-if="
            appointment.current_status == 1 && !showError && !testConference
          "
        >
          <div
            class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
            id="page-login"
          >
            <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
              <b-card :style="bgColor">
                <b-button
                  class="back-btn"
                  @click="redirectHome()"
                  :style="buttonCss"
                >
                  <b-icon icon="arrow-left" :variant="buttonCss.color"></b-icon
                ></b-button>
                <div class="profile-header app-details">
                  <div class="relative">
                    <div class="pointer-events">
                      <div>
                        <b-avatar
                          button
                          variant="light"
                          @click="redirectToWebsiteUrl"
                          class="img-center"
                          :class="
                            !appointment.enable_header_footer
                              ? ' avatar-default'
                              : ''
                          "
                          :src="
                            appointment.enable_header_footer
                              ? appointment.company_profile_image
                              : defaults
                          "
                          size="250px"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <h4 :style="textColor" class="text-center mt-10">
                  {{ $t("MeetingIsFinished") }}
                </h4>
              </b-card>
            </div>
          </div>
        </div>
        <div v-else>
          <audio src="@/assets/audio/speech.mp3" id="backgroundAudio" muted />

          <div v-if="testConference">
            <div id="conference" class="conference">
              <div id="testmeet" class="w-full confroom">
                <!-- sidebar ope -->

                <vs-sidebar
                  :hiddenBackground="true"
                  v-if="testConference"
                  position-right
                  id="user_sidebar1"
                  default-index="1"
                  color="primary"
                  v-model="active"
                  parent="#conference"
                >
                  <div class="visible">
                    <div class="">
                      <div class="vx-row device p-5">
                        <h6 class="w-full">
                          {{ $t("CallSettings") }}
                          <div class="float-right">
                            <feather-icon
                              icon="XIcon"
                              svgClasses=" cursor-pointer   "
                              class="cross"
                              @click="close"
                            ></feather-icon>
                          </div>
                        </h6>
                        <small class="w-full">
                          {{ $t("CustomDevice") }}
                        </small>
                      </div>
                      <vs-divider class="mb-0"></vs-divider>

                      <form
                        name="staff_form"
                        method="post"
                        v-on:submit.prevent="$event.preventDefault()"
                      >
                        <div class="vx-row">
                          <div class="vx-col w-full device">
                            <small for="num_identificativo"
                              >{{ $t("Camera") }}
                            </small>
                            <v-select
                              v-model="currentDevice.videoInput"
                              size="large"
                              :options="videoInput"
                              name="camera"
                              :data-vv-as="$t('Camera')"
                              :placeholder="$t('Camera')"
                              :clearable="true"
                              @input="inputChange"
                            />
                            <span
                              class="text-danger text-sm"
                              v-show="errors.has('camera')"
                              >{{ errors.first("camera") }}</span
                            >
                          </div>
                          <div class="vx-col w-full device">
                            <small for="num_identificativo"
                              >{{ $t("Microphone") }}
                            </small>

                            <v-select
                              v-model="currentDevice.audioInput"
                              :options="audioInput"
                              @input="inputChange"
                              size="large"
                              name="audio"
                              :data-vv-as="$t('Microphone')"
                              :placeholder="$t('Microphone')"
                              :clearable="true"
                            />
                            <span
                              class="text-danger text-sm"
                              v-show="errors.has('microphone')"
                              >{{ errors.first("microphone") }}</span
                            >
                          </div>
                          <div
                            v-if="audioOutput.length > 0"
                            class="vx-col w-full device"
                          >
                            <small for="num_identificativo"
                              >{{ $t("AudioOutput") }}
                            </small>
                            <v-select
                              v-model="currentDevice.audioOutput"
                              :options="audioOutput"
                              @input="inputChange"
                              size="large"
                              name="microphone"
                              :data-vv-as="$t('AudioOutput')"
                              :placeholder="$t('AudioOutput')"
                              :clearable="true"
                            />

                            <span
                              class="text-danger text-sm"
                              v-show="errors.has('audio')"
                              >{{ errors.first("audio") }}</span
                            >
                          </div>
                          <div class="vx-col w-full device">
                            <small for="num_identificativo"
                              >{{ $t("Background") }}
                            </small>
                            <b-button
                              variant="primary"
                              type="filled"
                              @click="changeBackground"
                              class="block w-full"
                              >{{ $t("Change") }}</b-button
                            >
                          </div>
                        </div>
                      </form>
                    </div>
                    <div class="w-full device flex">
                      <b-button
                        variant="primary"
                        type="filled"
                        @click.prevent="submitDevice"
                        class="mt-5 block"
                        >{{ $t("Ok") }}</b-button
                      >

                      <b-button
                        variant="outline-warning"
                        @click="close"
                        id="cancel"
                        class="mt-5 ml-5 block"
                        type="border"
                        >{{ $t("Cancel") }}</b-button
                      >
                    </div>
                  </div>
                </vs-sidebar>
                <!-- cloese -->
              </div>
            </div>
            <div class="w-full controls" id="controls" v-if="displayButtons">
              <div class="mt-5 w-full">
                <div class="center-button">
                  <div class="text-center">
                    <div v-if="video">
                      <span
                        class="custome-feathure-icon feather-icon select-none relative"
                      >
                        <feather-icon
                          svgClasses="w-8 h-8 cursor-pointer"
                          icon="VideoIcon"
                          @click="setVideo(video)"
                        />
                      </span>
                    </div>
                    <div v-else>
                      <span
                        class="custome-feathure-icon feather-icon select-none relative"
                      >
                        <feather-icon
                          svgClasses="w-8 h-8 cursor-pointer"
                          icon="VideoOffIcon"
                          @click="setVideo(video)"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="ml-5 text-center">
                    <span
                      class="custome-feathure-icon custome-feathure-icon-red feather-icon select-none relative"
                    >
                      <feather-icon
                        svgClasses="w-8 h-8 cursor-pointer"
                        icon="XIcon"
                        @click="exitMeeting()"
                      />
                    </span>
                  </div>
                  <div class="ml-5 text-center">
                    <div v-if="audio">
                      <span
                        class="custome-feathure-icon feather-icon select-none relative"
                      >
                        <feather-icon
                          svgClasses="w-8 h-8 cursor-pointer"
                          icon="MicIcon"
                          @click="setAudio(audio)"
                        />
                      </span>
                    </div>
                    <div v-else>
                      <span
                        class="custome-feathure-icon feather-icon select-none relative"
                      >
                        <feather-icon
                          svgClasses="w-8 h-8 cursor-pointer"
                          icon="MicOffIcon"
                          @click="setAudio(audio)"
                        />
                      </span>
                    </div>
                  </div>
                  <div class="setting-position">
                    <span
                      class="custome-feathure-icon feather-icon select-none relative"
                      :class="{
                        'custome-feathure-icon-active': active,
                      }"
                    >
                      <feather-icon
                        svgClasses="w-8 h-8 cursor-pointer"
                        @click="open"
                        icon="SettingsIcon"
                      />
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="w-full mt-5 text-center" v-if="!flag">
              <b-button
                type="filled"
                variant="primary"
                class="p-3 round-button"
                @click="enterUserButton"
              >
                <span class="inline-flex">{{ $t("JoinNow") }}</span>
              </b-button>
            </div>
            <div class="w-full mt-2 text-center">
              <div v-if="!showNotConnect">
                <h3 v-if="flag && !staffEnter">
                  {{ $t("UserMessage1") }}
                </h3>
                <h3 v-if="!flag && appointmentDetails.staff_entered">
                  {{ $t("UserMessage2") }}
                </h3>
              </div>
              <div class="department-list" v-if="showNotConnect || rejected">
                <h5>
                  {{ $t("WalkinsMeetingNotConnect") }}
                </h5>
                <h5 class="user mt-2">
                  <a :href="redirect">{{ $t("ScheduleMeeting") }}</a>
                </h5>
              </div>
            </div>
          </div>

          <div
            v-if="
              !showPayButton &&
              appointmentDetails.staff_entered &&
              enterRoom &&
              !testConference
            "
          >
            <div
              v-show="!showError && !testConference"
              class="custom-chat-container"
            >
              <div v-if="!showError" id="meet" class="w-full confroom"></div>
              <input
                ref="sendFile"
                type="file"
                v-validate="{
                  required: true,
                  size: 2048,
                }"
                class="hidden"
                accept="image/*, application/pdf"
                name="file"
                id="sendFile"
                @change="selectedChatFile($event)"
              />
              <span
                id="chat"
                class="cursor-pointer noblink"
                v-if="showChatIcon && !testConference"
              >
                <feather-icon
                  @click="showParticipant"
                  icon="MessageSquareIcon"
                />
                <span class="redDot" v-if="hasAnyUnreadMessage"></span>
              </span>

              <div
                v-if="showParticipants"
                class="chat-container container home-card border border-solid d-theme-dark-border rounded custom-card-css"
                :style="{
                  'background-image': `url(${require('@/assets/images/bg-chat-tile-light.png')})`,
                  'background-repeat': 'repeat',
                }"
              >
                <!-- <div id="chat-app" class="pt-2"> -->
                <!-- Chat Messages Start here -->
                <div class="chat__contact flex items-center px-2 pt-4 pb-2">
                  <div class="contact__avatar mr-1">
                    <avatar :size="35" :username="chatUser.user_name"> </avatar>
                  </div>
                  <div
                    class="contact__container w-full flex items-center justify-between overflow-hidden"
                  >
                    <div>
                      <!-- w - 4 / 6 -->
                      <div class="contact__info flex flex-col truncate">
                        <p class="font-semibold cursor-pointer mt-4">
                          {{ chatUser.user_name }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <ul
                  class="text-sm chat_align_botom w-full"
                  ref="messagesContainer"
                  @dragover="dragover"
                  @drop="drop"
                >
                  <template v-for="(message, index) in messageList">
                    <li
                      :class="{
                        'text-right':
                          message.sender_user_id == appointment.user_id &&
                          message.sender_user_role == 'user',
                      }"
                      :style="'margin: 15px 0px'"
                      :key="index"
                    >
                      <small
                        v-if="
                          (message.sender_staff || message.sender_user) &&
                          (message.sender_user_id != appointment.user_id ||
                            message.sender_user_role != 'user')
                        "
                      >
                        {{
                          message.sender_user_role == "staff"
                            ? message.sender_staff.first_name +
                              " " +
                              message.sender_staff.last_name
                            : message.sender_user.first_name +
                              " " +
                              message.sender_user.last_name
                        }}</small
                      >

                      <small> {{ message.created_at | displayDate }}</small>
                      <br />
                      <div v-if="message.file">
                        <a
                          class="chat-message"
                          :class="{
                            'message-span-right':
                              message.sender_user_id ==
                              $store.getters.currentUser.id,
                          }"
                        >
                          <feather-icon
                            v-if="
                              message.file.file_type == 'image' &&
                              message.sender_user_id ==
                                $store.getters.currentUser.id &&
                              message.sender_user_role ==
                                $store.getters.currentUser.user_role
                            "
                            :title="$t(message.file.file_name)"
                            icon="DownloadIcon"
                            @click.prevent="downloadFile(message.file)"
                            svgClasses="w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2 mr-2 items-start items-baseline"
                            :class="{
                              'message-span-right':
                                message.sender_user_id ==
                                $store.getters.currentUser.id,
                            }"
                          />

                          <auth-image
                            v-if="message.file.file_type == 'image'"
                            :path="message.file.path"
                            style="height: 80px; width: 80px"
                          />

                          <div v-else class="mt-1 mb-2">
                            <div
                              class="flex py-3 px-4 bg-white message-span"
                              :class="{
                                'message-span-right float-right':
                                  message.sender_user_id ==
                                  $store.getters.currentUser.id,
                              }"
                              style="width: fit-content"
                            >
                              <i
                                class="fa"
                                :class="
                                  fileIconList[message.file.file_type]
                                    ? fileIconList[message.file.file_type]
                                    : 'fa-file-o'
                                "
                                style="font-size: xx-large"
                              ></i>
                              <span class="ml-2" style="margin-top: 0.5rem">
                                {{ message.file.file_name }}
                              </span>
                              <i
                                class="ml-4 fa fa-arrow-circle-down"
                                style="font-size: large; margin-top: 0.5rem"
                                @click.stop="downloadFile(message.file)"
                              ></i>
                            </div>
                          </div>

                          <feather-icon
                            v-if="
                              message.file.file_type == 'image' &&
                              (message.sender_user_id !==
                                $store.getters.currentUser.id ||
                                message.sender_user_role !=
                                  $store.getters.currentUser.user_role)
                            "
                            @click.prevent="downloadFile(message.file)"
                            :title="$t(message.file.file_name)"
                            icon="DownloadIcon"
                            svgClasses="message-span w-5 h-5 hover:text-danger stroke-current"
                            class="ml-2 items-start items-baseline"
                          />
                        </a>
                      </div>
                      <div class="clearfix"></div>
                      <div
                        v-if="message && message.message.length > 0"
                        class="mt-1"
                      >
                        <a class="chat-message">
                          <chat-message
                            class="message-span"
                            :class="{
                              'message-span-right':
                                message.sender_user_id == appointment.user_id,
                            }"
                            :key="message.id"
                            :message-object="message"
                          ></chat-message>

                          <br />
                        </a>
                      </div>
                    </li>
                  </template>
                </ul>
                <div
                  class="chat-input-div centerx default-input vx-row w-full"
                  style="padding-right: 275px"
                >
                  <div
                    class="vx-col md:w-3/4 xl:w-3/4 custom-input-chat-div mt-5"
                  >
                    <vs-input
                      class="w-full"
                      placeholder="Type a message"
                      v-model="message"
                      v-on:keyup.enter="sendMessage()"
                      @paste="onPaste"
                    ></vs-input>
                  </div>
                  <div
                    class="md:w-1/7 xl:w-1/7 mr-2 mt-8 custom-input-chat-div-button"
                  >
                    <feather-icon
                      style="cursor: pointer"
                      icon="PaperclipIcon"
                      @click.prevent="
                        sendFile.prompt = true;
                        sendFile.preview = null;
                        directDrag = false;
                        copyFile = null;
                        sendFile.uploadProgress = 0;
                      "
                    />
                  </div>
                  <div
                    class="md:w-1/6 xl:w-1/6 mt-5 custom-input-chat-div-button"
                  >
                    <vs-button
                      :disabled="isDisabled"
                      class="w-full chat-button"
                      @click="sendMessage()"
                      >Send</vs-button
                    >
                  </div>
                </div>
                <!-- Chat Messages End here -->

                <div v-if="showParticipants && !showError && !testConference">
                  <div id="chat-app">
                    <vs-sidebar
                      :hiddenBackground="true"
                      :positionRight="true"
                      v-model="showParticipants"
                      id="chat-list-sidebar"
                      class="items-no-padding"
                      parent="#chat-app"
                    >
                      <!-- <feather-icon
                        icon="XIcon"
                        svgClasses=" cursor-pointer"
                        class="pull-right"
                        @click="showParticipants = !showParticipants"
                        style="float: right"
                      ></feather-icon> -->

                      <!-- Recent Chat list Start-->
                      <div class="chat__contacts pt-3">
                        <b class="text-lg text-primary mb-3 px-4"
                          >{{ $t("Chat") }}
                        </b>
                        <ul class="chat__contacts bordered-items text-sm">
                          <li class="">
                            <div
                              @click="createUserData('')"
                              class="chat__contact flex items-center px-2 pt-4 pb-2"
                            >
                              <div class="contact__avatar mr-1">
                                <avatar :size="35" :username="$t('GroupChat')">
                                </avatar>
                              </div>
                              <div
                                class="contact__container w-full flex items-center justify-between overflow-hidden"
                              >
                                <div
                                  class="contact__info flex flex-col truncate w-full"
                                >
                                  <div class="font-semibold cursor-pointer">
                                    {{ $t("GroupChat") }}
                                    <small
                                      class="pull-right"
                                      v-if="chatList.group_chat != null"
                                    >
                                      {{
                                        chatList.group_chat.created_at
                                          | displayDate
                                      }}
                                    </small>
                                    <feather-icon
                                      v-if="hasAnyUnreadMessageList"
                                      :class="{
                                        hide_message:
                                          !hasAnyUnreadMessageList['group'],
                                        show_message:
                                          hasAnyUnreadMessageList['group'],
                                      }"
                                      class="w-5"
                                      icon="MessageSquareIcon"
                                    />
                                  </div>
                                  <small v-if="chatList.group_chat != null">{{
                                    chatList.group_chat.message
                                  }}</small>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ul>
                      </div>
                      <!-- Recent chat List end -->
                      <div class="chat__contacts pt-3">
                        <b class="text-lg text-primary mb-3 px-4">
                          {{ $t("Participants") }} ({{
                            filteredeParticipants.length
                          }})
                        </b>

                        <vs-input
                          class="w-full mt-3 px-2 mt-1"
                          :value="search_participants"
                          @input="searchInput"
                          :icon-after="true"
                          icon="search"
                          placeholder=""
                        />
                      </div>

                      <VuePerfectScrollbar
                        :key="$vs.rtl"
                        :settings="{ maxScrollbarLength: 60, wheelSpeed: 0.7 }"
                        class="chat-scroll-area pt-4"
                      >
                        <ul class="chat__contacts bordered-items text-sm">
                          <li
                            class="text-sm"
                            v-for="(participant, idx) in filteredeParticipants"
                            :key="idx"
                          >
                            <div
                              class="chat__contact flex items-center px-2 pt-4 pb-2"
                              @click="chatUserData(participant, idx)"
                            >
                              <div class="contact__avatar mr-1">
                                <avatar
                                  :size="35"
                                  :username="participant.user_name"
                                >
                                  <!-- <img src="src" alt="alt"> -->
                                </avatar>
                              </div>
                              <p
                                class="font-semibold cursor-pointer mt-3 w-full"
                              >
                                {{ participant.user_name }}
                                <b
                                  v-if="
                                    appointment.user_id ==
                                      participant.user_id &&
                                    participant.user_role == 'user'
                                  "
                                  >({{ $t("You") }})</b
                                >
                                <feather-icon
                                  v-if="hasAnyUnreadMessageList"
                                  :class="{
                                    hide_message:
                                      !hasAnyUnreadMessageList[
                                        `${participant.user_role}-${participant.user_id}`
                                      ],
                                    show_message:
                                      hasAnyUnreadMessageList[
                                        `${participant.user_role}-${participant.user_id}`
                                      ],
                                  }"
                                  class="w-5"
                                  icon="MessageSquareIcon"
                                />
                              </p>
                            </div>
                          </li>
                        </ul>
                      </VuePerfectScrollbar>
                      <!-- </div> -->
                    </vs-sidebar>
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="!appointmentDetails.can_join"
              class="h-screen flex w-full bg-img vx-row no-gutter items-center justify"
              id="page-login"
            >
              <div class="vx-col w-full">
                <b-card>
                  <h4 class="a-center">{{ $t("RoomError1") }}</h4>
                </b-card>
              </div>
            </div>
            <div
              v-if="showError && appointmentDetails.can_join && !testConference"
              class="h-screen flex w-full bg-img vx-row no-gutter items-center justify"
              id="page-login"
            >
              <div
                class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"
              >
                <b-card>
                  <h4>{{ $t("RoomError") }}</h4>
                </b-card>
              </div>
            </div>
          </div>
          <div v-if="showPayButton">
            <div
              class="h-screen flex w-full bg-img vx-row no-gutter items justify"
              id="page-login"
            >
              <div
                class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4"
              >
                <b-card>
                  <h5>{{ $t("PaymentMsg") }}</h5>
                  <p>
                    <b-button
                      type="filled"
                      variant="primary"
                      class="mt-5"
                      @click="payForm()"
                      >{{ $t("PayNow") }}</b-button
                    >
                  </p>
                </b-card>
              </div>
            </div>
          </div>

          <b-card
            class="mt-10"
            v-if="
              (appointmentDetails.staff_entered == false ||
                enterRoom == false) &&
              !testConference
            "
          >
            <b-button
              class="back-btn"
              @click="redirectHome()"
              :style="buttonCss"
            >
              <b-icon icon="arrow-left" :variant="buttonCss.color"></b-icon
            ></b-button>
            <div v-if="!cancelApp && cancelFlag != 3">
              <div class="profile-header app-details">
                <div class="relative">
                  <div class="pointer-events">
                    <div>
                      <b-avatar
                        button
                        variant="light"
                        @click="redirectToWebsiteUrl"
                        class="img-center"
                        :class="
                          !appointment.enable_header_footer
                            ? ' avatar-default'
                            : ''
                        "
                        :src="
                          appointment.enable_header_footer
                            ? appointment.company_profile_image
                            : defaults
                        "
                        size="250px"
                      />
                    </div>
                  </div>
                  <div class="company-center mt-5" :style="textColor">
                    <h2 class="mt-2" :style="textColor">
                      {{ $t("Welcome1") }}
                    </h2>
                    <p class="mt-10" style="font-size: 17px">
                      <span v-if="!appointment.many_to_many">
                        {{ $t("AppointmentBookedText2") }}</span
                      >
                      <b>{{ appointment.staff_name + " " }}</b
                      ><span v-if="appointment.many_to_many">event</span>
                      <span v-if="is_missed"> {{ $t("ScheduleWas") }}</span>
                      <span v-else> {{ $t("ScheduleAt") }}</span>
                      <br />
                    </p>
                    <p
                      class="mt-2"
                      style="text-transform: capitalize; font-size: 17px"
                    >
                      <i class="feather icon-calendar mr-2"></i
                      >{{ scheduledAt }}
                    </p>
                    <p
                      class="mt-2"
                      style="text-transform: capitalize; font-size: 17px"
                    >
                      <i class="feather icon-phone mr-2"></i>
                      {{ appointment.company_contact }}
                    </p>
                  </div>
                  <div
                    class="appointment-details mt-10"
                    v-if="!appointmentDetails.can_join && !testConference"
                  >
                    <h5 class="user mt-2" :style="textColor">
                      {{ $t("RoomError1") }}
                    </h5>
                  </div>
                  <div
                    class="appointment-details mt-10"
                    :style="textColor"
                    v-if="
                      !is_rescheduled &&
                      appointmentDetails.can_join &&
                      !testConference
                    "
                  >
                    <div
                      class="department-list"
                      v-if="appointment.type != 'walkin'"
                    >
                      <h4 class="user" :style="textColor" v-if="!is_missed">
                        {{ $t("UserNotConnect") }}
                      </h4>
                      <h4 class="user" :style="textColor" v-if="is_missed">
                        {{ $t("UserMissedConnect") }}
                      </h4>
                      <div
                        class="row"
                        v-if="!is_missed"
                        :class="
                          appointmentDetails.staff_entered
                            ? 'col-md-8 md:col-md-8 lg:col-md-8 offset-book-15 '
                            : 'col-md-pp offset-books-21 '
                        "
                      >
                        <div class="w-full">
                          <!-- <h4 class="text-center">
                            {{ $t("EnterTheName") }} <span class="red">*</span>
                          </h4> -->

                          <b-form-input
                            size="lg"
                            v-validate="{ required: true }"
                            :data-vv-as="$t('Name')"
                            name="name"
                            v-model="meetName"
                            @blur="checkText"
                            @input="setUsername"
                            @keydown.enter="checkText"
                            class="w-full text-center"
                            :placeholder="$t('EnterTheName')"
                          ></b-form-input>
                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('name')"
                            >{{ errors.first("name") }}</span
                          >
                          <div class="md:flex xl:flex lg:flex">
                            <div
                              class="mrpx-10"
                              :class="
                                appointmentDetails.staff_entered
                                  ? enterClass
                                  : notEnterRoom
                              "
                            >
                              <b-button
                                type="filled"
                                variant="danger"
                                class="w-full mt-5 p-3 float-right mpr-3"
                                @click="cancelAppointment"
                                >{{ $t("CancelAppointment") }}</b-button
                              >
                            </div>
                            <div
                              v-if="
                                appointmentDetails.staff_entered &&
                                !alreadyInWaitingPage
                              "
                              class="mrpx-10"
                              :class="
                                appointmentDetails.staff_entered
                                  ? enterClass
                                  : notEnterRoom
                              "
                            >
                              <b-button
                                type="filled"
                                variant="info"
                                class="w-full mt-5 p-3 float-right mpr-3"
                                @click="enterButton"
                                >{{ $t("Enter") }}</b-button
                              >
                            </div>
                            <div
                              class="mrpx-10"
                              :class="
                                appointmentDetails.staff_entered
                                  ? enterClass
                                  : notEnterRoom
                              "
                            >
                              <b-button
                                type="filled"
                                variant="primary"
                                class="w-full mt-5 p-3 mpr-3"
                                :style="buttonCss"
                                @click="rescheduleAppointment"
                                >{{ $t("RescheduleAppointment") }}</b-button
                              >
                            </div>
                          </div>

                          <!-- setttings -->
                        </div>

                        <div
                          class="md:flex xl:flex lg:flex w-full mt-10 text-center"
                        >
                          <div
                            class="mrpx-10 w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2"
                          >
                            <b-button
                              type="filled"
                              variant="primary"
                              class="w-full mt-5 p-3 float-right mpr-3"
                              @click="testCall"
                            >
                              <span class="inline-flex"
                                ><feather-icon
                                  icon="VideoIcon"
                                  svgClasses="h-4 w-4"
                                  class="mr-1"
                                />{{ $t("MediaSettings") }}</span
                              >
                            </b-button>
                          </div>
                          <div
                            class="mrpx-10 w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2"
                          >
                            <b-button
                              type="filled"
                              variant="primary"
                              class="w-full mt-5 p-3 mpr-3"
                              :style="buttonCss"
                              @click="pingMe"
                              >{{ $t("PingMe") }}
                              {{ appointment.staff_name }}</b-button
                            >
                          </div>
                        </div>

                        <!-- end settings -->
                      </div>
                      <!-- if appointment is not missed -->
                      <div
                        class="row col-md-6 offset-books-25"
                        v-if="is_missed"
                      >
                        <div class="w-full">
                          <!-- <h4 class="text-center">
                            {{ $t("EnterTheName") }} <span class="red">*</span>
                          </h4> -->

                          <b-form-input
                            size="lg"
                            v-validate="{ required: true }"
                            :data-vv-as="$t('Name')"
                            name="name"
                            v-model="meetName"
                            class="w-full text-center"
                            @keydown.enter="checkForm"
                            :placeholder="$t('EnterTheName')"
                          ></b-form-input>
                          <span
                            class="text-danger text-sm"
                            v-show="errors.has('name')"
                            >{{ errors.first("name") }}</span
                          >

                          <div class="w-full">
                            <b-button
                              type="filled"
                              variant="primary"
                              class="mt-2 p-3 w-full"
                              :style="buttonCss"
                              @click="bookAppointment"
                              >{{ $t("BookAppointment1") }}</b-button
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      class="department-list"
                      v-if="
                        !showNotConnect &&
                        appointment.type == 'walkin' &&
                        !rejected
                      "
                    >
                      <h5 class="user" :style="textColor">
                        {{ $t("WalkinsMeetingText") }}
                      </h5>
                      <h5 class="user mt-2" :style="textColor">{{ timer }}</h5>
                    </div>
                    <div
                      v-if="!showNotConnect && appointment.type == 'walkin'"
                      class="md:flex xl:flex lg:flex w-full mt-10 text-center"
                    >
                      <div
                        class="mrpx-10 w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2"
                      >
                        <b-button
                          type="filled"
                          variant="primary"
                          class="w-full mt-5 p-3 float-right mpr-3"
                          @click="testCall"
                        >
                          <span class="inline-flex"
                            ><feather-icon
                              icon="VideoIcon"
                              svgClasses="h-4 w-4"
                              class="mr-1"
                            />{{ $t("MediaSettings") }}</span
                          >
                        </b-button>
                      </div>
                      <div
                        class="mrpx-10 w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2"
                      >
                        <b-button
                          type="filled"
                          variant="primary"
                          class="w-full mt-5 p-3 mpr-3"
                          :style="buttonCss"
                          @click="pingMe"
                          >{{ $t("PingMe") }}
                          {{ appointment.staff_name }}</b-button
                        >
                      </div>
                    </div>
                    <div
                      class="department-list"
                      v-if="showNotConnect || rejected"
                    >
                      <h5 class="user" :style="textColor">
                        {{ $t("WalkinsMeetingNotConnect") }}
                      </h5>
                      <h5 class="user mt-2" :style="textColor">
                        <a :href="redirect">{{ $t("ScheduleMeeting") }}</a>
                      </h5>
                    </div>
                  </div>
                  <div
                    class="appointment-details mt-10"
                    v-if="is_rescheduled && appointmentDetails.can_join"
                  >
                    <div class="department-list">
                      <h5 class="user mt-2" :style="textColor">
                        {{ $t("AlreadyScheduleMeeting") }}
                      </h5>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="cancelApp && cancelFlag != 3" class="error-msg">
              <h4 class="center" :style="textColor">
                {{ $t("AlreadyCancelMeetingMessage1") }}
              </h4>
            </div>
            <div v-if="cancelFlag == 3" class="error-msg mt-5">
              <h4 class="center">
                {{ $t("AppointmentNotFound") }}
              </h4>
            </div>
          </b-card>
        </div>
      </div>
    </b-overlay>
    <!-- setting sidebar -->
    <!-- sidebar -->
    <!-- Left sidebar -->

    <!-- SideBar -->

    <!-- end setting sidebar -->
    <vs-prompt
      :title="$t('SendFile')"
      class="fileupload"
      @cancel="
        sendFile.prompt = false;
        directDrag = false;
        copyFile = null;
        sendFile.uploadProgress = 0;
      "
      @accept="sendingFile()"
      :accept-text="$t('Send')"
      :cancel-text="$t('Cancel')"
      @close="sendFile.prompt = false"
      :active="sendFile.prompt"
    >
      <form @submit.prevent.stop>
        <DropFileChat
          :fileDetails="fileDetails"
          @selectedFile="selectedChatFile"
          :url.sync="sendFile.preview"
          :directDrag="directDrag"
        />
        <b-form-input
          v-on:keyup.enter="sendingFile()"
          class="mt-2"
          v-model="sendFile.message"
          :placeholder="$t('TypeYourMessage')"
        ></b-form-input>
      </form>
      <b-progress
        v-if="sendFile && sendFile.uploadProgress"
        :value="sendFile.uploadProgress"
        variant="primary"
        class="mt-5"
        show-value
        animated
      ></b-progress>
    </vs-prompt>
    <a href="" ref="downloader" download="file"></a>
  </div>
</template>
<style>
.lang-mb {
  margin-bottom: -20px !important;
}
.avatar-default .b-avatar-img {
  width: auto !important;
  height: auto !important;
  border-radius: initial !important;
}
.avatar-default .b-avatar-img img {
  width: 80% !important;
}
#conference .vs-sidebar.vs-sidebar-parent {
  /* position: absolute; */
  height: 81% !important;
  /* max-height: 700px; */
  /* top: 0; */
}
#conference .vs-sidebar {
  max-width: 330px !important;
}

.setting-position {
  position: absolute;
  right: 10px;
}
.visible {
  position: relative !important;
  overflow-y: scroll !important;
  height: 100% !important;
  overflow-x: none !important;
  margin-bottom: 10px !important;
  padding: 1rem !important;
}
.center-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
.device {
  margin-left: 15px;
  margin-right: 15px;
  margin-top: 10px;
}
</style>
<style scoped>
.list3 {
  margin: 0;
  position: absolute;
  left: 48%;
  top: 50%;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}
.custome-feathure-icon {
  border-radius: 50%;
  padding: 5px;
  box-shadow: 1px 0px 3px #888878;
}
.custome-feathure-icon .feather-icon {
  padding: 5px;
}
.custome-feathure-icon-red {
  background: red;
  color: #fff !important;
}
.custome-feathure-icon-green {
  background: green;
  color: #fff !important;
}
.color-font {
  color: #626262 !important;
  width: 60%;
  margin-left: 25%;
  display: flex;
}
.mrpx-10 {
  /* display: block; */
  margin-right: 10px;
}
.mpl-1 {
  margin-left: 2%;
}
.mpr-1 {
  margin-left: 2%;
}
.wd-20 {
  width: 20%;
}
/* .wd-50{
width: 100%;
} */
.input-box {
  display: grid;

  justify-content: center;
  /*
display: block; */
}
.bookbtn {
  position: relative;
  left: 45%;
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}
.confroom {
  display: block; /* iframes are inline by default */
  background: rgb(179, 177, 177);
  border: none; /* Reset default border */
  height: 520px; /* Viewport-relative units */
  width: 100vw;
}
.a-center {
  text-align: center;
}

.company-center .text {
  border-bottom: #7367f0 1px dotted;
}

.app-details .img-center {
  display: block;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.app-details .company-center {
  text-align: center;
}

.pay-now {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}

.success {
  margin-left: auto;
  margin-right: auto;
  text-align: center;
}
.user {
  text-align: center;
}

section.ps-container.chat-scroll-area.pt-4.ps.ps--theme_default {
  height: 100%;
}
.chat-container {
  position: absolute;
  overflow: hidden;
  width: 100%;
  padding-top: unset;
  border-radius: 5px;
  right: 0;
  bottom: 0;
  top: 0;
  width: 700px;
}

.message-span {
  background: #fff;
  color: #000;
  padding: 10px 15px;
  border-radius: 0px 25px 25px 25px;
  box-shadow: 1px 1px 10px #ddd;
  display: inline-block;
  text-align: justify;
}

.message-span-right {
  border-radius: 25px 25px 0px 25px;
  text-align: left !important;
}

.chat_align_botom {
  overflow-y: scroll;
  padding: 20px 275px 20px 0px;
  bottom: 100px;
  width: 100%;
  position: absolute;
  top: 75px;
  bottom: 75px;
}

.chat-input-div {
  position: absolute;
  bottom: 10px;
}

.vs-button {
  margin-right: 20px !important;
  text-align: center;
}
#chat-app {
  .vs-sidebar--background {
    position: absolute;
    z-index: 40000;
  }

  #chat-list-sidebar,
  #chat-profile-sidebar {
    .vs-sidebar {
      max-width: 300px;
    }
  }

  #chat-list-sidebar {
    .chat-scroll-area {
      position: relative;
      margin: auto;
      width: 100%;
      height: 70%;
      &:not(.ps) {
        overflow-y: auto;
        height: calc(100%+10px);
      }

      .chat__contact {
        transition: background-color 0.1s;

        &:hover {
          background-color: #eee;
        }
      }
    }
  }
}
.custom-chat-container {
  position: relative;
}
.noblink {
  position: absolute !important;
  bottom: 3.3% !important;
  left: 5% !important;
  color: #fff !important;
  background: #131519 !important;
  padding: 9px 8px 5px 8px !important;
  border-radius: 22px !important;
}
.blink-chat {
  position: absolute !important;
  bottom: 3.3% !important;
  left: 5% !important;
  color: #fff !important;
  background: #131519 !important;
  padding: 9px 8px 5px 8px !important;
  border-radius: 22px !important;
  /*animation: blinker 1s step-start infinite;*/
}
.col-md-pp {
  flex: 0 0 58.333333%;
  max-width: 63.333333%;
}

.offset-book-25 {
  margin-left: 15%;
}
.offset-book-10 {
  margin-left: 10%;
}
.offset-book-15 {
  margin-left: 16.666667%;
}
.offset-books-25-button {
  margin-left: 25%;
}
.offset-3s {
  margin-left: 25%;
}
.offset-books-25 {
  margin-left: 25%;
}
.offset-books-21 {
  margin-left: 20%;
}

@media only screen and (max-width: 767px) {
  .col-md-pp {
    max-width: 100%;
  }
  .color-font {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .offset-books-25 {
    margin-left: 0;
  }
  .offset-books-21 {
    margin-left: 0;
  }
  .offset-book-15 {
    margin-left: 0;
  }
  .offset-book-25 {
    margin-left: 0px;
  }
  .offset-book-10 {
    margin-left: 0px;
  }
  .offset-3s {
    margin-left: 0px;
  }
}
@media only screen and (min-width: 1000px) and (max-width: 1600px) {
  .noblink {
    position: absolute;
    bottom: 3% !important;
    left: 5% !important;
    right: unset;
    padding: 9px 10px 5px 10px !important;
    border-radius: 22px;
    z-index: 1000 !important;
  }
  .blink-chat {
    position: absolute;
    bottom: 3% !important;
    left: 5% !important;
    right: unset;
    padding: 9px 10px 5px 10px !important;
    border-radius: 22px;
    z-index: 1000 !important;
  }
}

@media only screen and (max-width: 300px) {
  .noblink {
    position: absolute;
    bottom: 12% !important;
    left: 5% !important;
    right: unset;
    padding: 9px 10px 5px 10px !important;
    border-radius: 22px;
    z-index: 1000 !important;
  }
  .blink-chat {
    position: absolute;
    bottom: 12% !important;
    left: 5% !important;
    right: unset;
    padding: 9px 10px 5px 10px !important;
    border-radius: 22px;
    z-index: 1000 !important;
  }
}
@keyframes blinker {
  50% {
    opacity: 0;
  }
}

span.w-5.feather-icon.select-none.relative {
  float: right;
  color: blue;
  animation: blink 1s;
  animation-iteration-count: 5;
}
.hide_message {
  display: none;
}

.show_message svg.feather.feather-message-square {
  width: 18px;
  margin-right: 10px;
}
.show_message {
  display: block;
}
@keyframes blink {
  50% {
    color: #fff;
  }
}

@media (min-width: 1050px) and (max-width: 5464px) {
  .confroom {
    height: 85vh; /* Viewport-relative units */
  }
}
</style>
<style>
.vx-navbar-wrapper.navbar-default {
  display: none;
}
@media (max-width: 767px) {
  .custom-input-chat-div-button {
    width: 25%;
  }
  .custom-input-chat-div {
    width: 75%;
  }
}
@media (max-width: 575px) {
  button.vs-component.vs-button.w-full.chat-button.vs-button-primary.vs-button-filled {
    padding: 10px 0;
  }
  ul.chat__contacts.bordered-items.text-sm {
    max-height: 300px;
    overflow-y: scroll;
  }
  .custom-input-chat-div-button {
    width: 25%;
  }
  .custom-input-chat-div {
    width: 75%;
  }
  div#chat-list-sidebar {
    margin-bottom: 15px;
  }
  .chat_align_botom {
    padding: 20px 10px !important;
    position: relative !important;
  }
  .chat-input-div {
    position: relative !important;
    padding-right: 0px !important;
    margin-top: 80px;
  }
  .chat-container {
    position: relative !important;
    width: 100% !important;
  }
  ul.text-sm.chat_align_botom.w-full {
    height: 300px;
    overflow-y: scroll;
    top: 30px;
  }
  .vs-sidebar.vs-sidebar-parent {
    position: relative !important;
    max-width: 100%;
  }
}
.redDot {
  background: red;
  border-radius: 10px;
  position: absolute;
  top: -2px;
  width: 2px;
  right: 0;
  padding: 6px;
}
.layout--full-page {
  padding: 2.2rem;
}
.card {
  width: 100%;
  background: transparent;
}
.card-body {
  border-radius: 10px;
  border: 2px solid white;
}
/* .scroll::-webkit-scrollbar-thumb {
    background: #ffffff !important;
}
.scroll::-webkit-scrollbar-track {
    background: rgba(255,255,255,0.5) !important;
} */
.confhub .confirm-button {
  border-radius: 10px;
}
.b-avatar.btn:not(:disabled):not(.disabled):hover .b-avatar-img img,
[dir] .b-avatar[href]:not(:disabled):not(.disabled):hover .b-avatar-img img {
  transform: unset !important;
}

.message-span a {
  text-decoration: underline !important;
  color: #000;
}

.custom-input-chat-div-button .vs-button {
  padding: 0.75rem 1rem !important;
}
</style>
<script>
if (!Boolean(document.referrer)) {
  const urlSearch = new URLSearchParams(window.location.search);
  const key = urlSearch.get("key");
  if (!Boolean(key)) window.location.href = "/";
  let uuid = window.atob(key).split("&")[1];
  const redirectTo = `/confhub/room/${uuid}`;
  window.location.href = redirectTo;
  throw "Redirect to " + redirectTo;
}

import vSelect from "vue-select";
import moment from "moment";
import $ from "jquery";
import {
  getUserAppUuid,
  getCurrentUserId,
  getFileIconList,
} from "@/utils/helper";
import Cookies from "js-cookie";
import { Validator } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import Avatar from "vue-avatar";
import "moment-timezone";
import * as PusherPushNotifications from "@pusher/push-notifications-web";
import { getErrorMessage } from "@/utils/helper";
import "@/utils/prevent-back";
import { getConferenceRoomDetails } from "@/api/rooms";
import AuthImage from "@/components/auth/image";
import I18n1 from "@/layouts/components/navbar/components/I18n1.vue";
import DropFileChat from "@/components/DropFileChat.vue";
import { saveEventChat } from "@/api/appointment.js";
import { mapGetters } from "vuex";
import ChatMessage from "@/components/chat-message";
import { getFile } from "@/api/staff";
import { datetime_tz, date_tz, time_tz } from "../../utils/datetime";
import dateLocaleIT from "date-fns/locale/it";
import dateLocaleEnUS from "date-fns/locale/en-US";

let chat_head_id = 0;
const channels = {
  private: [],
  public: [],
  walkinDepartment: [],
};

let bufferTimer = null;
let waitingTimer = null;
let missedTimer = null;
let reminderTimer = null;
const maxAllowedMins = 1440;

export default {
  data() {
    return {
      percentage: 0,
      uploadFileProgress: "",
      defaults: require("@/assets/images/logo/bip.png"),
      displayButtons: false,
      flag: false,
      staffEnter: false,
      devices: [],
      currentDevice: [],
      active: false,

      audioDevice: "",
      videoDevice: "",
      outputDevice: "",
      testConference: false,
      temp: "",
      api: [],
      displayUser: [],
      audioDevice: "",
      microphone: "",
      camera: "",
      audioInput: [],
      audioOutput: [],
      videoInput: [],
      audio: false,
      video: false,
      enterClass: "w-full xs:w-full sm:w-full lg:w-1/3 md:w-1/3 xl:w-1/3",
      notEnterRoom: "w-full xs:w-full sm:w-full lg:w-1/2 md:w-1/2 xl:w-1/2",
      enterRoom: false,
      room: "",
      userInfo: {},
      showError: false,
      userId: "",
      showPayButton: false,
      uuid: "",
      appointmentDetails: [],
      alreadyJoined: false,
      markedPresece: false,
      videoConf: [],
      timer: "0 : 0",
      showNotConnect: false,
      updateMissedCallFlag: true,
      is_rescheduled: null,
      can_join: false,
      interval: null,
      timeSaved: false,
      waitingTime: null,
      show: false,
      variant: "light",
      opacity: 0.85,
      blur: "2px",
      error: "",
      success: "",
      sec: 2,
      counter: 0,
      onlineParticipants: [],
      filteredeParticipants: [],
      chatUser: {
        user_name: this.$t("GroupChat"),
        user_id: "0",
        user_role: "",
      },
      message: "",
      chatList: [],
      isDisabled: false,
      showParticipants: false,
      search_participants: "",
      isDisabled: false,
      showChatIcon: false,
      blinkArray: [],
      rejected: false,
      redDot: false,
      cancelApp: 0,
      cancelFlag: 0,
      buttonCss: {},
      textColor: {},
      meetName: "",
      alreadyInWaitingPage: "",
      joinNowClick: false,
      bgColor: {},
      sendFile: {
        prompt: false,
        preview: null,
        file: null,
        message: "",
        uploadProgress: 0,
      },
      is_notify: false,
      directDrag: false,
      fileDetails: null,
      fileIconList: getFileIconList(),
    };
  },

  components: {
    Avatar,
    VuePerfectScrollbar,
    "v-select": vSelect,
    AuthImage,
    I18n1,
    DropFileChat,
    ChatMessage,
  },
  filters: {
    displayDate(v) {
      if (v) {
        var data = moment(v).calendar({
          sameDay: "[Today] HH:mm",
          lastDay: "[Yesterday] HH:mm",
          lastWeek: "dddd HH:mm",
          sameElse: "DD MMM YYYY HH:mm",
        });
        return data;
      }
    },
  },

  computed: {
    ...mapGetters({
      messageList: "chatMessages",
    }),
    scheduledAt() {
      if (
        !this.appointment ||
        !this.appointment.start_datetime ||
        !this.appointment.end_datetime
      )
        return null;
      const start = new Date(this.appointment.start_datetime);
      const end = new Date(this.appointment.end_datetime);
      const locale = this.$i18n.locale == "it" ? dateLocaleIT : dateLocaleEnUS;
      if (date_tz(start) == date_tz(end)) {
        return `${time_tz(start)} - ${datetime_tz(
          end,
          "KK:mm a eeee, MMMM 	dd, yyyy",
          locale
        )}`;
      }
      return `${datetime_tz(start)} - ${datetime_tz(end)}`;
    },
    conferenceActiveChatHeads() {
      const uuid = this.appointment.conference_uuid || this.appointment.uuid;
      const participants = this.onlineParticipants;
      const heads = this.$store.state.chat.heads;
      return heads.filter((head) => {
        if (head.appointment_uuid == uuid) return true;
        return (
          participants.findIndex(
            (p) => p.user_role == head.user_role && p.user_id == head.user_id
          ) > -1
        );
      });
    },
    hasAnyUnreadMessageList() {
      const list = {};
      this.conferenceActiveChatHeads.forEach((head) => {
        if (Boolean(head.appointment_uuid))
          list["group"] = head.seen_reports_count > 0;
        else
          list[`${head.user_role}-${head.user_id}`] =
            head.seen_reports_count > 0;
      });
      return list;
    },
    hasAnyUnreadMessage() {
      return (
        this.conferenceActiveChatHeads.findIndex(
          (head) => head.seen_reports_count > 0
        ) > -1
      );
    },
    redirect() {
      Cookies.remove("appointment_id_reschedule");
      Cookies.set("appointment_id_reschedule", this.appointment.id);

      if (this.appointment.is_premium == 0)
        return "/" + this.appointment.company_slug;
      else {
        return (
          "/" +
          this.appointment.company_slug +
          "/direct/" +
          this.appointment.department_slug +
          "/reschedule"
        );
      }
    },
    appointment() {
      if (!this.appointmentDetails || !this.appointmentDetails.appointment)
        return null;
      return this.appointmentDetails.appointment;
    },
    is_missed() {
      if (!this.appointment) return false;
      if (this.appointment.is_missedcall == 1) return true;
      let now = new Date();
      let end_time = new Date(this.appointment.end_time_at);
      return this.appointment.current_status == 0 && now > end_time;
    },
  },
  async mounted() {
    let channelName = null;
    if (this.$store.getters.currentUser.id) {
      this.loadLocale(this.$i18n.locale);
      this.userId = this.$store.getters.currentUser.id;
      this.userInfo = {
        email: this.$store.getters.currentUser.email,
        displayName:
          this.$store.getters.currentUser.first_name +
          " " +
          this.$store.getters.currentUser.last_name,
      };

      this.meetName =
        this.$store.getters.currentUser.first_name +
        " " +
        this.$store.getters.currentUser.last_name;
    } else {
      this.userId = getCurrentUserId();
    }
    if ($("#room-name").val() != undefined) {
      this.room = $("#room-name").val();
    } else {
      this.room = this.$route.params.room;
    }

    await this.checkRoom();

    const setupPresence = {
      role: "user",
      userId: this.appointment.user_id,
      appointmentId: this.appointment.id,
      token: sessionStorage.getItem(
        `APPOINTMENT-LOGIN-${this.appointment.uuid}`
      ),
      company_id: this.appointment.company_id,
    };

    const userAppUUID = getUserAppUuid();
    const uuid = this.appointment.conference_uuid || this.appointment.uuid;

    if (setupPresence.token) {
      this.$store.commit("SET_TOKEN", setupPresence.token);
      await this.$store.dispatch("userAuthVerify");
      this.$store.dispatch("initUserMessageChannel");
      await this.$store.dispatch(
        "staffOnlineIdsInit",
        setupPresence.company_id
      );
      this.$store.dispatch("GetChatAndContact", { ignore: ["contacts"] });
      this.$store.dispatch("GetChatMessages");
    }

    channelName = `appointment-${uuid}`;
    channels.public.push(channelName);
    Echo.join(channelName);

    channelName = "staffConnected" + userAppUUID;
    channels.public.push(channelName);
    Echo.channel(channelName).listen("StaffConnected", (response) => {
      if (this.flag) this.staffEnter = true;
      if (this.flag && this.staffEnter) {
        this.flag = false;
      }

      if (this.joinNowClick == true) this.exitMeeting();

      if (!this.testConference) {
        this.joinNowClick = true;
      }

      setTimeout(() => {
        $("#backgroundAudio")[0].play();
        setTimeout(() => {
          $("#backgroundAudio")[0].pause();
        }, 2000);
      }, 1000);
      // if already not joined
      if (this.alreadyJoined == false) {
        this.checkRoom("");
        clearInterval(this.interval);
      }
      this.getConferenceParticipantList();
      if (this.meetName) {
        this.saveUsername();
      }
    });

    channels.public.push("staffDisconnected" + userAppUUID);
    Echo.channel("staffDisconnected" + userAppUUID).listen(
      "StaffDisconnected",
      (response) => {
        if (this.$route.name == "conference") {
          this.checkRoom("stop");
          clearInterval(this.interval);
          //this.showChatIcon = false;
          let data = {
            appointment_id: this.appointment.id,
            user_conference_status: "left",
            fireEvent: true,
          };
          this.$store.dispatch("userAvailableUnavalibleEvent", data);
        }
      }
    );

    channels.public.push("appointmentRejected");
    Echo.channel("appointmentRejected").listen(
      "AppointmentRejected",
      (response) => {
        if (response.data.appointment_id == this.appointment.id) {
          this.rejected = response.data.is_rejected;
          if (this.rejected) clearInterval(this.interval);
          console.log("rejected response", response.data.is_rejected);
        }
      }
    );

    channels.public.push("userConnected" + userAppUUID);
    Echo.channel("userConnected" + userAppUUID).listen(
      "UserConnected",
      (response) => {
        const eventIndex = this.onlineParticipants.findIndex(
          (value) =>
            value.user_id == response.data.user_id && value.user_role == "user"
        );
        if (eventIndex == -1) {
          this.onlineParticipants.push({
            user_name: response.data.user_name,
            first_name: response.data.user_first_name,
            last_name: response.data.user_last_name,
            user_id: response.data.user_id,
            user_role: "user",
          });
          const search = this.search_participants.toUpperCase();
          this.filteredeParticipants = this.onlineParticipants.filter(function (
            elem
          ) {
            return elem.user_name.toUpperCase().includes(search);
          });
        }
      }
    );

    channels.public.push("userDisconnected" + userAppUUID);
    Echo.channel("userDisconnected" + userAppUUID).listen(
      "UserDisconnected",
      (response) => {
        this.testConference = false;
        this.displayButtons = false;
        const eventIndex = this.onlineParticipants.findIndex(
          (value) =>
            value.user_id == response.data.user_id && value.user_role == "user"
        );
        if (eventIndex != -1) {
          enterUserButton;
          this.onlineParticipants.splice(eventIndex, 1);
          const search = this.search_participants.toUpperCase();
          this.filteredeParticipants = this.onlineParticipants.filter(function (
            elem
          ) {
            return elem.user_name.toUpperCase().includes(search);
          });
        }
      }
    );

    channels.public.push("staffDisconnected" + userAppUUID);
    Echo.channel("staffDisconnected" + userAppUUID).listen(
      "StaffDisconnected",
      (response) => {
        const eventIndex = this.onlineParticipants.findIndex(
          (value) =>
            value.user_id == response.data.user_id && value.user_role == "staff"
        );
        if (eventIndex != -1) {
          this.onlineParticipants.splice(eventIndex, 1);
          const search = this.search_participants.toUpperCase();
          this.filteredeParticipants = this.onlineParticipants.filter(function (
            elem
          ) {
            return elem.user_name.toUpperCase().includes(search);
          });
        }
      }
    );

    this.getCompanyDetails();
    if (this.meetName) {
      this.saveUsername();
    }
  },

  beforeDestroy() {
    this.testConference = false;
    this.displayButtons = false;
    clearInterval(this.interval);
    waitingTimer && clearTimeout(waitingTimer);
    bufferTimer && clearTimeout(bufferTimer);
    missedTimer && clearTimeout(missedTimer);
    channels.private.forEach((channel) => {
      window.Echo.leave(`private-${channel}`);
    });
    channels.public.forEach((channel) => {
      window.Echo.leave(`${channel}`);
    });
  },
  methods: {
    dragover(e) {
      e.preventDefault();
    },
    drop(e) {
      e.preventDefault();
      var file = e.dataTransfer.files[0];
      var filePath = file.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
      // if (!allowedExtensions.exec(filePath)) {
      //   this.$toasted.show(this.$t("FileUploadError"), {
      //     className: "top-alert",
      //     position: "top-center",
      //     type: "error",
      //     duration: 2000,
      //   });
      // } else {
      this.sendFile.prompt = true;
      this.directDrag = true;
      this.selectedChatFile(file);
      this.sendFile.uploadProgress = 0;
      //}
    },
    onPaste(event) {
      const clipboardData = event.clipboardData || window.clipboardData;
      const items = clipboardData.items;
      let imageFile = {};
      for (let i = 0; i < items.length; i++) {
        imageFile = items[i].getAsFile();
      }

      var filePath = imageFile.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
      // if (!allowedExtensions.exec(filePath)) {
      //   this.$toasted.show(this.$t("FileUploadError"), {
      //     className: "top-alert",
      //     position: "top-center",
      //     type: "error",
      //     duration: 2000,
      //   });
      // } else {
      this.sendFile.prompt = true;
      this.selectedChatFile(imageFile);
      this.sendFile.uploadProgress = 0;
      // }
    },
    async downloadFile(file) {
      const response = await getFile(file.path);
      let url = URL.createObjectURL(response.data);
      const a = this.$refs.downloader;
      a.setAttribute("href", url);
      a.setAttribute("download", file.file_name);
      a.click();
    },
    selectedChatFile(file) {
      this.sendFile.file = file;
      this.fileDetails = {
        file_name: file.name,
        file_type: file.name
          .substring(file.name.lastIndexOf(".") + 1, file.name.length)
          .toLowerCase(),
      };
      this.sendFile.preview = file.type.includes("image")
        ? URL.createObjectURL(file)
        : null;
      //this.sendFile.preview = file.type=="application/pdf"?this.$store.state.app.pdfIconUrl:URL.createObjectURL(file);
    },
    sendingFile() {
      this.message = this.sendFile.message;
      $(".fileupload .vs-dialog-accept-button").prop("disabled", true);
      $(".fileupload input").prop("disabled", true);
      this.sendMessage();
    },
    inputChange(val) {
      this.active = false;
      this.active = true;
    },
    generateNumber() {
      return Math.floor(Math.random() * (99999 - 10000 + 1)) + 10000;
    },
    addDevice(id) {
      if (this.currentDevice.audioInput != null) {
        this.setAudioInputDevice(
          id,
          this.currentDevice.audioInput.label,
          this.currentDevice.audioInput.deviceId
        );
      }
      if (this.currentDevice.audioOutput != null) {
        this.setAudioOutputDevice(
          id,
          this.currentDevice.audioOutput.label,
          this.currentDevice.audioOutput.deviceId
        );
      }
      if (this.currentDevice.videoInput != null) {
        this.setVideoInputDevice(
          id,
          this.currentDevice.videoInput.label,
          this.currentDevice.videoInput.deviceId
        );
      }
    },
    submitDevice() {
      //  let id=this.appointment.uuid;
      this.saveConferenceDevice();
      // this.close();
      this.show = false;
    },
    saveConferenceDevice() {
      this.show = true;
      let data = {
        camera: this.currentDevice.videoInput,
        microphone: this.currentDevice.audioInput,
        audio: this.currentDevice.audioOutput,
        appointment_id: this.appointment.id,
      };
      this.$store
        .dispatch("SaveUserConferenceDeviceApi", data)
        .then((res) => {
          this.show = false;
          this.getConferenceDeviceApi();

          this.$toasted.show(this.$t("SaveConferenceApiMessage"), {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 4000,
          });
        })
        .catch((error) => {
          this.show = false;
          console.log("SaveConferenceApi", error);
          return false;
        });
    },
    getConferenceDeviceApi(id = null) {
      this.show = true;
      let data = {
        appointment_id: this.appointment.id,
      };
      this.$store
        .dispatch("GetUserConferenceDeviceApi", data)
        .then((res) => {
          this.show = false;

          // this.getCurrentDevices(id);
          this.demo = res.data.data;
          let device = res.data.data;
          if (
            device.camera == null ||
            device.audio == null ||
            device.microphone == null
          ) {
            // this.getCurrentDevices(id);
          } else {
            this.currentDevice.videoInput = JSON.parse(device.camera);
            this.currentDevice.audioOutput = JSON.parse(device.audio);
            this.currentDevice.audioInput = JSON.parse(device.microphone);
          }
        })
        .catch((error) => {
          console.log("getConferenceApi", error);
          return false;
        });
    },
    // close
    close() {
      this.active = false;
    },
    open() {
      this.active = true;
    },
    exitMeeting() {
      this.api.executeCommand("hangup");
      this.api.dispose();
      this.testConference = false;
      this.displayButtons = false;
      this.getCustomStyle();
      if (this.showNotConnect) {
        clearInterval(this.interval);
      }
    },
    testCall() {
      this.testConference = true;
      this.flag = false;
      this.staffEnter = false;
      this.joinNowClick = false;
      setTimeout(() => {
        this.initConf("testmeet");
        this.showNotConnect = false;
        // clearInterval(this.interval);
      }, 1000);
    },
    setUsername(text) {
      if (text) {
        this.filteredeParticipants.forEach((element, index) => {
          if (element.user_id == this.appointment.user_id) {
            element.user_name = text || this.meetName;
          }
        });
      }
    },
    displayName(id) {
      const displayName = this.api.getDisplayName(id);
    },
    checkText(str) {
      if (this.meetName) this.saveUsername();
    },
    /**
     * save username
     */
    async saveUsername() {
      this.success = "";
      this.error = "";
      this.show = true;
      let data = {
        appointment_id: this.appointment.id,
        conference_user_name: this.meetName,
        audio: this.audio ? 1 : 0,
        video: this.video ? 1 : 0,
      };

      await this.$store
        .dispatch("SaveUsernames", data)
        .then((res) => {
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : Welcome.vue | Function : saveUsername() | Error :",
            error
          );
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },
    changeBackground() {
      let check = this.api.executeCommand("toggleVirtualBackgroundDialog");
      let id = this.api._onStageParticipant;
      const avatarURL = this.api.getParticipantsInfo();
    },
    setAudio(audio) {
      this.audio = !audio;
      this.saveUsername();
      if (this.testConference) {
        this.api.isAudioMuted().then((muted) => {
          this.api.executeCommand("toggleAudio");
          this.audio = muted;
        });
      }
    },
    setVideo(video) {
      this.video = !video;
      this.saveUsername();
      if (this.testConference) {
        this.api.isVideoMuted().then((muted) => {
          this.api.executeCommand("toggleVideo");
          this.video = muted;
        });
      }
    },
    /**
     * company details
     */
    getCompanyDetails() {
      this.success = "";
      this.error = "";

      this.show = true;
      this.$store
        .dispatch("CompanyDetails", this.appointment.company_slug)
        .then((res) => {
          this.show = false;
        })
        .catch((error) => {
          this.$log.error(
            "File : Welcome.vue | Function : getCompanyDetails() | Error :",
            error
          );
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },
    enterUserButton() {
      this.flag = true;
      this.joinNowClick = true;
      if (this.appointmentDetails.staff_entered && this.testConference) {
        //  this.exitMeeting();
        this.api.executeCommand("hangup");
        this.api.dispose();
        this.testConference = false;
        this.displayButtons = false;
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.enterRoom = true;
            setTimeout(() => {
              this.initConf();
              this.showNotConnect = false;
              clearInterval(this.interval);
            }, 1000);
          }
        });
      } else if (
        !this.appointmentDetails.staff_entered &&
        this.testConference
      ) {
        // this.flag=true;
        this.staffEnter = false;
      }
    },
    enterButton() {
      this.testConference = false;
      this.$validator.validateAll().then((result) => {
        console.log("result----", result);
        if (result) {
          this.enterRoom = true;
          setTimeout(() => {
            this.initConf();
            this.showNotConnect = false;
            clearInterval(this.interval);
          }, 1000);
        }
      });
    },
    beforeunloadHandler(e) {
      let dataVal = {
        appointment_id: this.appointment.id,
        user_conference_status: "left",
        fireEvent: true,
      };

      this.$store.dispatch("userAvailableUnavalibleEvent", dataVal);

      const data = {
        appointment_id: this.appointment.id,
        user_id: this.appointment.user_id,
        user_role: "user",
      };
      this.$store
        .dispatch("LeftRoom", data)
        .then((res) => {})
        .catch((error) => {
          return false;
        });
      e.preventDefault();
      return null;
    },
    redirectHome() {
      location.href = "/" + this.appointment.company_slug;
    },
    rescheduleAppointment() {
      location.href = this.appointment.reschedule_link;
    },
    bookAppointment() {
      location.href = this.appointment.booking_link;
    },
    async cancelAppointment() {
      const isOK = await this.$swal({
        title: this.$t("CancelMeetingAlert"),
        type: "warning",
        showCancelButton: true,
        confirmButtonText: this.$t("Yes"),
        confirmButtonColor: "#7367F0",
        cancelButtonText: this.$t("No"),
        showCloseButton: true,
        showLoaderOnConfirm: true,
      });
      if (!isOK.value) return;

      let id = this.appointment.id || null;
      this.show = true;
      const data = {
        cancel_by_user: true,
        id: id,
      };
      this.$store
        .dispatch("CancelMeeting", data)
        .then((res) => {
          this.show = false;
          this.cancel = "";
          //this.$router.push("/" + this.cancelSlug).catch(() => {});
          this.success = this.$t("CancelMeetingMessage");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
          setTimeout(this.redirectHome, 1000);
        })
        .catch((error) => {
          this.$log.error(
            "src/frontend/Conference.vue | Function : cancelMeeting() | Error :",
            error
          );
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },
    getSettings() {
      this.$store
        .dispatch("GetSystemSettings")
        .then((res) => {
          // $(".bg-img").css(
          //   "background-image",
          //   "url(" + res.data.data.background_image.path + ")"
          // );
        })
        .catch((error) => {
          this.$log.error(
            "src/frontend/Conference.vue | Function : getSettings() | Error :",
            error
          );

          this.$vs.loading.close();
          // Error response
          this.$vs.notify({
            title: this.$t("Error"),
            text: getErrorMessage(error, this),
            color: "danger",
            position: "top-center",
          });
          return false;
        });
    },
    /**
     * vee validate with multi lang
     */
    loadLocale(code) {
      return import("vee-validate/dist/locale/" + code).then((locale) => {
        Validator.localize(code, locale);
      });
    },
    /**
     * check room availablity
     */
    async checkRoom(type) {
      this.success = "";
      this.error = "";
      // this.$vs.loading();
      this.show = true;
      var data = {
        room_name: this.room,
        user_id: this.userId,
        user_role: "user",
        uuid: localStorage.getItem("uuid"),
        users_name: this.meetName,
      };

      try {
        const res = await this.$store.dispatch("CheckRoom", data);
        const appointment = res.data.data.appointment;
        this.room = res.data.data.room_name;
        const now = new Date();
        const sta = new Date(appointment.start_time_at);
        const eta = new Date(appointment.end_time_at);

        this.show = false;
        if (appointment.is_before_buffer_mins && bufferTimer == null) {
          bufferTimer && clearTimeout(bufferTimer);
          // javascript setTimeout max time issue fixes
          if (appointment.buffer_mins_left < maxAllowedMins) {
            bufferTimer = setTimeout(
              function () {
                bufferTimer = null;
                this.checkRoom();
              }.bind(this),
              appointment.buffer_mins_left * 60000
            );
          }
        }

        if (sta > now) {
          waitingTimer && clearTimeout(waitingTimer);
          const timer = sta - now;
          if (timer / 60000 < maxAllowedMins) {
            waitingTimer = setTimeout(
              function () {
                waitingTimer = null;
                this.checkRoom();
              }.bind(this),
              timer
            );
          }
        }

        if (eta && appointment.is_missedcall != 1 && eta > now) {
          missedTimer && clearTimeout(missedTimer);
          missedTimer = setTimeout(
            function () {
              this.$set(
                this.appointmentDetails.appointment,
                "is_missedcall",
                1
              );
            }.bind(this),
            eta - now
          );
        }

        this.appointmentDetails = res.data.data;
        this.audio = this.appointmentDetails.appointment.user.is_audio_on
          ? true
          : false;
        this.video = this.appointmentDetails.appointment.user.is_video_on
          ? true
          : false;
        this.getCustomStyle();
        this.cancelApp = this.appointment.is_cancelled || 0;
        this.cancelFlag = this.appointment.current_status || 0;
        this.getSettings();
        if (!this.meetName) this.meetName = this.appointment.user_name;
        if (this.appointment) {
          this.userInfo = {
            displayName: this.meetName,
          };

          if (this.meetName == "") this.meetName = this.appointment.user_name;
        }
        this.can_join = this.appointmentDetails.can_join;
        if (
          this.appointment.is_premium &&
          this.appointment.payment_status != 1
        ) {
          this.$router.push({
            path: "/appointmentpay/" + this.appointment.uuid,
          });
        } else {
          this.videoConf = this.appointmentDetails.room_domain_and_engine;
          if (this.appointmentDetails.staff_entered == false) {
            this.alreadyInWaitingPage = true;
          }
          this.is_rescheduled = res.data.data.is_rescheduled;
          this.appointment.start_time = moment(
            this.appointment.start_time,
            "hh:mm A"
          ).format("hh:mm A");
          this.appointment.end_time = moment(
            this.appointment.end_time,
            "hh:mm A"
          ).format("hh:mm A");
          if (
            appointment.waiting_page_alert_sent == 0 &&
            !appointment.is_before_buffer_mins &&
            this.appointmentDetails.staff_entered == false &&
            this.appointment.type != "walkin"
          ) {
            // set reminder only if it was not set before
            this.setReminder();
            // reminderTimer = setTimeout(this.setReminder, 1000 * 60 * 5);
            clearInterval(this.interval);
          } else if (this.appointment.type == "walkin" && type == "stop") {
            if (this.appointment.is_walkin_completed == 1) {
              this.leftRoom();
              // this.$router.push({ path: "/" });
            }
            clearInterval(this.interval);
          } else if (this.appointment.type == "one-to-one" && type == "stop") {
            this.leftRoom();
            // this.$router.push({ path: "/" });
            clearInterval(this.interval);
          } else if (this.appointment.is_missed_call == 1) {
            this.showNotConnect = true;
            clearInterval(this.interval);
          }

          this.rejected = this.appointmentDetails.is_rejected;
          if (this.rejected) clearInterval(this.interval);

          if (
            res.data.data.is_premium &&
            res.data.data.payment_status != 1 &&
            res.data.data.is_rescheduled != 1
          ) {
            this.showPayButton = true;
          } else {
            if (res.data.data.is_available) {
              if (
                this.appointmentDetails.staff_entered != false &&
                (this.appointment.type == "walkin" ||
                  (this.alreadyInWaitingPage && this.joinNowClick))
              ) {
                this.enterRoom = true;
                setTimeout(() => {
                  this.joinNowClick = false;
                  this.initConf();
                  this.showNotConnect = false;
                  clearInterval(this.interval);
                }, 1000);
              }
              // mark presence
              console.log("type---this.markedPresece", this.markedPresece);

              if (!this.markedPresece) this.joinRoom();
            } else {
              this.show = false;
              // Error response
              this.error = this.$t("RoomError");
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
            }
            // mark presence
            console.log(
              "type---this.appointmentDetails.can_join",
              this.appointmentDetails.can_join
            );
            if (this.appointmentDetails.can_join) this.joinRoom();
            else {
              this.showError = true;

              this.show = false;
              // Error response
              this.error = this.$t("RoomError1");
              this.$toasted.show(this.error, {
                className: "top-alert",
                position: "top-center",
                type: "error",
                duration: 2000,
              });
            }
          }
        }
      } catch (error) {
        this.$log.error(
          "src/frontend/Conference.vue | Function : checkRoom() | Error :",
          error
        );
        this.show = false;
        // Error response
        this.error = this.$t("RoomError");
        this.$toasted.show(getErrorMessage(error, this), {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
        return false;
      }
    },

    /**
     * waiting time cal
     */
    pad(val) {
      var valString = val + "";
      if (valString.length < 2) {
        return "0" + valString;
      } else {
        return valString;
      }
    },

    /**
     * save waiting time
     */
    saveWaitingTime(id, time) {
      var timeData = {
        appointment_id: id,
        waiting_time: "05:00",
      };

      this.$store
        .dispatch("SetWaitingTime", timeData)
        .then((res) => {})
        .catch((error) => {
          this.$log.error(
            "src/frontend/Conference.vue | Function : saveWaitingTime() | Error :",
            error
          );
          return false;
        });
    },

    /**
     *  submitForm method for submiting form
     **/
    async initConf(id = "meet") {
      console.log("-------", $("#" + id).html());
      let check1 = !$("#" + id).html();
      //  let check2=!$("#meet1").html();
      if (check1) {
        const domain = this.videoConf.room_domain;
        this.api = [];
        if (this.meetName) {
          this.userInfo = {
            displayName: this.meetName,
          };
        }
        const options = {
          roomName: this.testConference
            ? `Test-${this.generateNumber()}-`
            : this.room,
          parentNode: document.querySelector("#" + id),
          userInfo: this.userInfo,
          configOverwrite: {
            startWithAudioMuted: !this.audio,
            startWithVideoMuted: !this.video,
            prejoinPageEnabled: false,
          },
          interfaceConfigOverwrite: {
            MOBILE_APP_PROMO: true,
            TOOLBAR_BUTTONS: this.testConference
              ? []
              : ["microphone", "camera", "tileview", "hangup", "desktop"],
          },
        };

        let pin = this.appointment.room_pin;
        if (!this.testConference) {
          const confRes = await getConferenceRoomDetails({
            company_id: this.appointment.company_id,
            name: options.roomName,
          });
          if (confRes.data.status == "success") {
            pin = confRes.data.data.pin;
            options.roomName = confRes.data.data.slug;
          } else options.roomName = roomData.conference_room;
        }

        const api = new JitsiMeetExternalAPI(domain, options);

        // When user left
        api.on("participantLeft", (res) => {
          this.alreadyJoined = false;
          //this.leftRoom();
        });
        // When user joined
        api.on("participantJoined", (res) => {
          this.alreadyJoined = true;
          if (!this.markedPresece) this.joinRoom();
        });

        api.on("readyToClose", () => {
          if (this.testConference) {
            this.displayButtons = false;
          }
          this.leftRoom();
          this.testConference = false;
          this.showChatIcon = false;
          let data = {
            appointment_id: this.appointment.id,
            user_conference_status: "left",
            fireEvent: true,
          };
          setTimeout(() => {
            this.$store.dispatch("userAvailableUnavalibleEvent", data);
            // this.$router.push({ path: "/" });
            this.appointment.current_status = 1;
          }, 1000);
        });

        api.on("videoConferenceJoined", (res) => {
          this.displayUser = res;
          if (this.appointment.department.is_enable_chat == 1)
            this.showChatIcon = true;
          let data = {
            appointment_id: this.appointment.id,
            user_conference_status: "join",
            fireEvent: true,
          };
          this.$store.dispatch("userAvailableUnavalibleEvent", data);
          if (this.testConference) {
            api.getAvailableDevices().then((devices) => {
              console.log("rtest device", devices);
              this.devices = devices;
              this.audioInput = devices.audioInput.filter(
                (audioInput) => audioInput.label != ""
              );

              this.audioOutput = devices.audioOutput.filter(
                (audioOutput) => audioOutput.label != ""
              );
              this.videoInput = devices.videoInput.filter(
                (videoInput) => videoInput.label != ""
              );
              this.getConferenceDeviceApi();
            });
            this.displayButtons = true;
          }
          this.api = api;
        });
        api.on("videoConferenceLeft", (res) => {
          console.log("videoConferenceLeft", res);
        });

        if (this.appointment.is_pin == 0) {
          // set new password for channel
          api.addEventListener("participantRoleChanged", function (event) {
            if (event.role == "moderator") api.executeCommand("password", pin);
          });

          // join a protected channel
          api.on("passwordRequired", function () {
            api.executeCommand("password", pin);
          });
          let event = "screenSharingStatusChanged";
          api.addListener(event, (res) => {
            if (res.on) {
              api.isVideoMuted().then((muted) => {
                if (!muted) {
                  api.executeCommand("toggleCamera");
                }
              });
            }
          });
        }
        this.api = api;
      }
    },
    /**
     * staff joined room
     */
    async joinRoom() {
      const requestData = {
        appointment_id: this.appointment.id,
        user_id: this.appointment.user_id,
        user_role: "user",
      };
      try {
        if (!this.is_notify) {
          this.$store.dispatch("joinNotificationToSM", this.appointment.id);
          this.is_notify = true;
        }
        const res = await this.$store.dispatch("JoinRoom", requestData);
        var data1 = {
          appointment_id: this.appointment.id,
          is_start_time_update: 1,
          is_device: false,
        };
        // this.$store.dispatch("updateRealStartEndTime", data1);
        this.getConferenceParticipantList();
        this.markedPresece = true;

        let data = {
          appointment_id: this.appointment.id,
          user_conference_status: "join",
        };
        this.$store.dispatch("userAvailableUnavalibleEvent", data);

        if (
          this.appointmentDetails.staff_entered == false &&
          this.appointment.type == "walkin"
        ) {
          var d2 = new Date(res.data.data.duration.waiting_time_end_at);
          this.timer = "00 : 00";
          var totalSeconds = 0;
          this.timeSaved = false;
          this.interval && clearInterval(this.interval);
          this.interval = setInterval(() => {
            let app_id = this.appointment.id;
            if (!localStorage.getItem(app_id)) {
              localStorage.setItem(app_id, new Date());
            }

            var d = new Date(); //get current time

            var seconds = Math.round(Math.floor(d - d2) / 1000);
            var fiveMin = 60 * 5; //five minutes is 300 seconds!

            var timeleft = fiveMin - (seconds + 300); // let's say now is 01:30, then current seconds is 60+30 = 90. And 90%300 = 90, finally 300-90 = 210. That's the time left!
            var min = "0" + parseInt(timeleft / 60);
            var sec = timeleft % 60;
            ++totalSeconds;
            this.waitingTime =
              this.pad(parseInt(seconds / 60)) +
              ":" +
              this.pad((seconds + 4) % 60);

            if (sec <= 9) {
              sec = "0" + sec;
            }
            var result = min + " : " + sec; //formart seconds back into mm:ss
            this.timer = result;
            if (this.timer == "00 : 01" || timeleft <= 0) {
              this.showNotConnect = true;
              this.updateMissedCallApi();
              localStorage.removeItem(app_id);
              clearInterval(this.interval);
            }
          }, 1000); //calling it every 0.5 second to do a count down
        }
      } catch (error) {
        console.error(error);
      }
    },

    /**
     * staff joined room
     */
    setReminder() {
      const data = {
        appointment_id: this.appointment.id,
      };
      console.log("SetReminder");
      this.$store
        .dispatch("SetReminder", data)
        .then((res) => {
          "response", res;
        })
        .catch((error) => {
          return false;
        });
    },
    /**
     * left room
     */
    leftRoom() {
      let data = {
        appointment_id: this.appointment.id,
        user_id: this.appointment.user_id,
        user_role: "user",
      };

      this.$store
        .dispatch("LeftRoom", data)
        .then((res) => {
          this.getCustomStyle();
          this.updateRealStartEndTime(0);
          clearInterval(this.interval);
          data = {
            appointment_id: this.appointment.id,
            user_conference_status: "left",
          };
          this.$store.dispatch("userAvailableUnavalibleEvent", data);
        })
        .catch((error) => {
          return false;
        });
    },

    updateRealStartEndTime(type) {
      return;
      var data = {
        appointment_id: this.appointment.id,
        is_start_time_update: type,
        is_device: false,
      };
      this.$store.dispatch("updateRealStartEndTime", data);
    },

    /**
     * redirect to payment page
     */
    payForm() {
      let routeData = this.$router.resolve({
        path: "/appointmentpay/" + this.uuid,
      });
      window.open(routeData.href, "_blank");
    },

    /**
     * Update Missed call Flag
     */
    updateMissedCallApi() {
      if (this.updateMissedCallFlag) {
        var data = {
          appointment_id: this.appointment.id,
          is_missed_call: 1,
        };
        this.$store
          .dispatch("UpdateMissedCallFlag", data)
          .then((res) => {
            this.updateMissedCallFlag = false;
            this.saveWaitingTime(this.appointment.id, this.waitingTime);
          })
          .catch((error) => {
            return false;
          });
      }
    },

    /**
     * left room
     */
    staffLeftRoom(id) {
      var data = {
        appointment_id: this.appointment.id,
        user_id: id,
        user_role: "staff",
      };
      this.$store
        .dispatch("LeftRoom", data)
        .then((res) => {})
        .catch((error) => {
          return false;
        });
    },

    chatUserData(userData, eventIndex) {
      userData.hasNewMessage = false;

      const index = this.blinkArray.indexOf(eventIndex);
      if (index > -1) {
        this.blinkArray.splice(index, 1);
      }
      $("#chat").removeClass("blink-chat");
      $("#chat").addClass("noblink");
      if (
        userData.user_id != this.appointment.user_id ||
        userData.user_role != "user"
      ) {
        if (userData.user_name == undefined)
          this.chatUser = {
            first_name: "",
            last_name: "",
            user_name: "",
            user_id: "0",
            user_role: "user",
          };
        else this.chatUser = userData;
        this.getUserMessages();
      }
    },

    createUserData(userData) {
      const index = this.blinkArray.indexOf(0);
      if (index > -1) {
        this.blinkArray.splice(index, 1);
      }
      $("#chat").removeClass("blink-chat");
      $("#chat").addClass("noblink");
      if (userData.first_name == undefined) {
        this.chatUser = {
          user_name: this.$t("GroupChat"),
          user_id: "0",
          user_role: "",
          first_name: "",
          last_name: "",
        };
        this.hasNewGroupMsg = false;
      } else {
        this.chatUser = {
          user_name: userData.user_name,
          first_name: userData.first_name,
          last_name: userData.last_name,
          user_id: userData.id,
          user_role: userData.user_role,
        };
      }
      this.getUserMessages();
    },

    getConferenceParticipantList() {
      var data = {
        appointment_id: this.appointment.id,
        conference_uuid: this.appointment.conference_uuid,
      };
      this.$store
        .dispatch("getConferenceParticipantList", data)
        .then((res) => {
          this.getUserMessages();
          this.getChatList();
          this.onlineParticipants = res.data.data.user_list;
          const search = this.search_participants.toUpperCase();
          this.filteredeParticipants = this.onlineParticipants.filter(function (
            elem
          ) {
            return elem.user_name.toUpperCase().includes(search);
          });
        })
        .catch((error) => {
          return false;
        });
    },

    searchInput(e) {
      this.search_participants = e;
      const search = this.search_participants.toUpperCase();
      this.filteredeParticipants = this.onlineParticipants.filter(function (
        elem
      ) {
        return elem.user_name.toUpperCase().includes(search);
      });
    },

    async sendMessage() {
      try {
        if (!this.sendFile.prompt && !this.message.length) return false;
        this.isDisabled = true;
        let formdata = new FormData();
        formdata.append("message", this.message);
        formdata.append("sender_user_id", this.appointment.user_id);
        formdata.append("receiver_user_id", this.chatUser.user_id);
        formdata.append("appointment_id", this.appointment.id);
        formdata.append("sender_user_role", "user");
        formdata.append("receiver_user_role", this.chatUser.user_role);

        if (this.sendFile.prompt) formdata.append("file", this.sendFile.file);

        const res = await saveEventChat(formdata, (progressEvent) => {
          this.sendFile.uploadProgress =
            Math.floor((progressEvent.loaded / progressEvent.total) * 100) - 5;
        });

        // const response = await this.$store.dispatch(
        //   "saveEventChat",
        //   formdata
        // );
        this.getChatList();
        this.message = "";

        if (this.sendFile.prompt)
          this.sendFile = {
            ...this.sendFile,
            prompt: false,
            file: null,
            message: "",
            preview: null,
            uploadProgress: 0,
          };

        this.directDrag = false;

        clearInterval(this.uploadFileProgress);
        this.percentage = 0;

        this.isDisabled = false;
      } catch (error) {
        this.isDisabled = false;
      }
    },
    scrollToEnd() {
      setTimeout(() => {
        var content = this.$refs.messagesContainer;
        if (content) content.scrollTop = content.scrollHeight;
      }, 100);
    },

    getUserMessages() {
      if (!this.appointment.id) {
        this.$store.commit("SET_ACTIVE_CHAT", { chat_head_id: 0 });
        return;
      }
      const uuid = this.appointment.conference_uuid || this.appointment.uuid;
      const reciever_user_role =
        this.chatUser.user_role != "user" ? "staff" : "user";
      const reciever_user_id = this.chatUser.user_id;

      const req = {
        appointment_id: this.appointment.id,
        uuid,
        reciever_user_role,
        receiver_user_id: [reciever_user_id, this.appointment.user_id],
      };

      let chatHead;
      if (reciever_user_id == 0) {
        chatHead = this.$store.state.chat.heads.find(
          (head) => head.is_group && head.appointment_uuid == uuid
        );
      } else {
        chatHead = this.$store.state.chat.heads.find(
          (head) =>
            !head.is_group &&
            head.user_role == reciever_user_role &&
            head.user_id == reciever_user_id
        );
      }

      if (chatHead) {
        chat_head_id = chatHead.id;
        this.$store.commit("SET_ACTIVE_CHAT", { chat_head_id });
        this.scrollToEnd();
      } else {
        const m = reciever_user_id == 0 ? "appointment" : reciever_user_role;
        const n = reciever_user_id == 0 ? uuid : reciever_user_id;
        chat_head_id = `${m}-${n}`;
        this.$store.commit("SET_ACTIVE_CHAT", {
          chat_head_id: this.showParticipants ? chat_head_id : 0,
        });
      }

      // this.$store
      //   .dispatch("getMessageList", req)
      //   .then((resp) => {
      //     $("#chat").removeClass("blink-chat");
      //     $("#chat").addClass("noblink");
      //     this.messageList = [];
      //     setTimeout(() => {
      //       this.messageList = resp.data.data;
      //     }, 10);
      //     this.scrollToEnd();
      //   })
      //   .catch((error) => {
      //     this.$log.error(
      //       "src/frontend/Conference.vue | Function : getUserMessages()",
      //       error
      //     );

      //     this.$vs.notify({
      //       title: this.$t("Error"),
      //       text: getErrorMessage(error, this),
      //       color: "danger",
      //       position: "top-center",
      //     });
      //   });
    },

    async getChatList() {
      try {
        const resp = await this.$store.dispatch("getChatList", {
          appointment_id: this.appointment.id,
          receiver_user_id: this.appointment.user_id,
        });
        this.chatList = resp.data;
      } catch (error) {
        this.$log.error(
          "src/frontend/Conference.vue | Function : getChatList()",
          error
        );
        const msg = getErrorMessage(e, this);
        this.$vs.notify({
          title: this.$t("Error"),
          text: msg,
          color: "danger",
          position: "top-center",
        });
      }
    },

    showParticipant() {
      const uuid = this.appointment.conference_uuid || this.appointment.uuid;
      this.redDot = false;
      this.showParticipants = !this.showParticipants;
      this.scrollToEnd();
      $("#chat").removeClass("blink-chat");
      $("#chat").addClass("noblink");
      if (!this.showParticipants) {
        chat_head_id = this.$store.state.chat.head_id;
        this.$store.commit("SET_ACTIVE_CHAT", { chat_head_id: 0 });
      } else {
        if (chat_head_id == `appointment-${uuid}`) {
          const groupHead = this.conferenceActiveChatHeads.find(
            (h) => h.appointment_uuid == uuid
          );
          if (groupHead) chat_head_id = groupHead.id;
        }
        this.$store.dispatch("markActiveChatHead", chat_head_id);
      }
      // setTimeout(() => {
      //   this.blinkArray.forEach((entry) => {
      //     if (entry == 0) {
      //       $("#group_chat_class").removeClass("hide_message");
      //       $("#group_chat_class").addClass("show_message");
      //     } else {
      //       $("#group_chat_class" + entry).removeClass("hide_message");
      //       $("#group_chat_class" + entry).addClass("show_message");
      //     }
      //   });
      // }, 500);
    },

    getCustomStyle() {
      let data = {
        company_id: this.appointment.company_id,
        department_id: this.appointment.department_id,
      };
      this.$store
        .dispatch("GetCustomStyle", data)
        .then((res) => {
          if (res.data.data.footer_text)
            $(".footer-text").html(res.data.data.footer_text);

          $(".card-body").css({
            "background-color": res.data.data.form_background_color,
          });

          $(".custome-text-color").css({
            color: res.data.data.form_text_color,
          });
          this.textColor = { color: res.data.data.form_text_color };
          this.buttonCss = {
            "background-color":
              res.data.data.button_background_color + "!important",
            "border-color":
              res.data.data.button_background_color + "!important",
            color: res.data.data.button_text_color,
          };
          $(".the-footer p, .the-footer a").css({
            color: res.data.data.form_text_color,
          });
          if (res.data.data.background_images) {
            $(".layout--full-page").css({
              "background-image":
                "url('" + res.data.data.background_images.path + "')",
              "background-position": "inherit",
              "background-repeat": "no-repeat",
              "background-size": "cover",
              "background-attachment": "fixed",
            });
            $(".content-area-reduced").css({
              "background-image":
                "url('" + res.data.data.background_images.path + "')",
              "background-position": "inherit",
              "background-repeat": "no-repeat",
              "background-size": "cover",
              "background-attachment": "fixed",
            });
          } else {
            $(".layout--full-page").css({ "background-image": "none" });
            $(".content-area-reduced").css({ "background-image": "none" });
          }
        })
        .catch((error) => {
          this.$log.error(
            "File : BookingForm.vue | Function : getCustomStyle() | Error :",
            error
          );
          // Error response
          this.error =
            this.$t(error.replace(/[\s\/]/g, "")) !==
            error.replace(/[\s\/]/g, "")
              ? this.$t(error.replace(/[\s\/]/g, ""))
              : error;
          this.$toasted.show(this.error, {
            className: "top-alert",
            position: "top-center",
            type: "error",
            duration: 2000,
          });
          return false;
        });
    },

    redirectToWebsiteUrl() {
      if (this.appointment.company_slug) {
        window.open("/" + this.appointment.company_slug, "_self");
      }
    },

    pingMe() {
      let id = this.appointment.id || null;
      this.show = true;
      let data = {
        appointment_id: id,
      };

      this.$store
        .dispatch("pingMe", data)
        .then((res) => {
          this.show = false;
          //this.$router.push("/" + this.cancelSlug).catch(() => {});
          this.success = this.$t("PingMeMessage");
          this.$toasted.show(this.success, {
            className: "top-alert",
            position: "top-center",
            type: "success",
            duration: 2000,
          });
        })
        .catch((error) => {
          this.$log.error(
            "src/frontend/Conference.vue | Function : cancelMeeting() | Error :",
            error
          );
          this.show = false;
          this.errorMsg = true;
          return false;
        });
    },
  },
};
</script>
